import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import DatePicker from "react-multi-date-picker";
import { useSelector } from "react-redux";

import { CERTIFICATE_TYPE, Secritariat_labels_values, TechnologyFieldsOptions, findTechnologyField, Panelist_labels_values, Time_Slot_Options } from "../../data/NewApplicantsConstants";
import FormInputLayout from "../FormInputLayout";
import { colourStylesFullWidth } from "../../data/Constants";
import PlainButton from "../buttons/PlainButton";
import moment from "moment";
import { newApplicantsService } from "../../services/newApplicantsService";

function ApplicationReadyForAssessmentForm({ closePopup, handleSubmit, loading, id }) {
    const initialValues = {
        session_date: "",
        // technology_field: "",
        panelist: [],
        secretariat: "",
        slots: [],
    };
    const [addPanelist, setAddPanelist] = useState([]);
    const personal = useSelector((state) => state.newApplicants?.profileData?.profile?.technology_field);
    const applicantId = id; // Assuming you have a way to track the current applicant's ID

    const personaTachField = useSelector((state) =>
        state.newApplicants?.data?.applicants?.find(
            (applicant) => applicant?.id == applicantId
        )?.user?.profile?.technology_field
    );

    const TSTCType = useSelector((state) => state.newApplicants?.data?.applicants?.[0]?.user?.profile?.preferred_registration);
    const certificateType = useSelector((state) => state.newApplicants?.certificateType);
    // const [loading, setLoading] = useState(false);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [sessionDate, setSessionDate] = useState(null);
    // Calculate tomorrow's date
    const tomorrow = moment().add(1, "days").set({ hour: 0, second: 0, millisecond: 0 }).toDate();
    const changeIDsStatus = useSelector((state) => state?.general?.selectedIDforStatusChange);
    // Use the value from the personal data to find the technology field
    useEffect(() => {
        const fetchAvailableSlots = async (sessionDate) => {
            try {
                // setLoading(true);
                const response = await newApplicantsService.availableSlots(moment(sessionDate).format("YYYY-MM-DD"));
                const availableSlots = response?.data?.data?.filter((slot) => slot.interview_id).map((slot) => slot.slot);

                const filteredSlots = Time_Slot_Options.filter((option) => !availableSlots.includes(option.value)); // Filter out the slots that are already in use;

                setAvailableSlots(filteredSlots);
                // setLoading(false);
            } catch (error) {
                console.error("Error fetching available slots:", error);
                // setLoading(false);
            }
        };

        if (sessionDate) {
            fetchAvailableSlots(sessionDate);
        }
    }, [sessionDate]);

    const validationSchema = Yup.object().shape({
        session_date: Yup.date().required("Session date is required"),
        panelist: Yup.array().min(1, "At least one panelist must be selected").required("Panelist is required"),
        secretariat: Yup.string().required("Secretariat is required"),
        slots: Yup.array()
            .min(changeIDsStatus?.length > 0 ? changeIDsStatus?.length : 1, `You must select at least ${changeIDsStatus?.length > 0 ? changeIDsStatus.length : 1} slot(s)`)
            .test(
                'slots-availability',
                `Available slots are less than the required number of slots (${changeIDsStatus?.length})`,
                function (value) {
                    return value?.length >= (changeIDsStatus?.length > 0 ? changeIDsStatus.length : 1);
                }
            )
            .required("Minimum 1 slot is required"),
    });

    // Determine the technology field value
    const technologyFieldValue = personal || personaTachField;
    const Panelist_labels_values = TechnologyFieldsOptions?.find(
        (field) => field?.value === technologyFieldValue
    ) ? TechnologyFieldsOptions.find(
        (field) => field?.value === technologyFieldValue
    )?.panelist : [];
    return (
        <div>
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize={true}>
                {({ setFieldValue, values, errors }) => (
                    <Form className="stepper-form-container">
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <div className="fs-6 text-gray-300 fw-400 mb-3 mb-lg-0">Session</div>
                                <div className="fs-20 text-gray-950 fw-700 mb-2 mb-lg-0">
                                    {(certificateType === CERTIFICATE_TYPE.PROFESSIONAL_TECHNOLOGIST || TSTCType === CERTIFICATE_TYPE.GRADUATE_TECHNOLOGIST) ? "Ts. " : "Tc. "}
                                    Assessment
                                </div>
                            </div>
                            {/* {changeIDsStatus.length <= 1 && ( */}
                            <div className="col-md-8">
                                <div className="fs-6 text-gray-300 fw-400 mb-3 mb-lg-0">Technology Field</div>
                                <div className="fs-20 text-gray-950 fw-700 mb-2 mb-lg-0">{findTechnologyField(personal === undefined ? personaTachField : personal)}</div>
                            </div>
                            {/* )} */}
                        </div>
                        <FormInputLayout label="Session Date" formikName="session_date" required={false}>
                            <DatePicker
                                value={values.session_date ? moment(values.session_date, "YYYY-MM-DD").toDate() : null}
                                onChange={(date) => {
                                    const formattedDate = date ? moment(date.toDate()).format("YYYY-MM-DD") : "";
                                    setFieldValue("session_date", formattedDate);
                                    setSessionDate(formattedDate);
                                }}
                                placeholderText="Session Date"
                                minDate={tomorrow} // Prevents selecting past dates
                                format="DD MMMM YYYY"
                                months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                            />
                            <ErrorMessage name="session_date" component="div" className="text-danger fs-14 fw-400 mt-1" />
                        </FormInputLayout>
                        <FormInputLayout label="Time Slot(s)" formikName="slots" required={false}>
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                styles={colourStylesFullWidth}
                                options={availableSlots}
                                components={{
                                    Option: (props) => {
                                        return (
                                            <div
                                                className="checkbox-wrapper"
                                                style={{
                                                    display: "inline-block",
                                                    width: "calc(50% - 1px)",
                                                    padding: "5px 10px",
                                                    borderLeft:
                                                        props.options.indexOf(props.data) % 2 !== 0 && props.options.indexOf(props.data) !== props.options.length - 1 ? "1px solid #D9D9D9" : "none",
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={`styled-checkbox-${props.data.value}`}
                                                    className="styled-checkbox"
                                                    checked={props.isSelected}
                                                    onChange={() => {
                                                        // Toggle the selection
                                                        props.selectOption(props.data);
                                                    }}
                                                />
                                                <label htmlFor={`styled-checkbox-${props.data.value}`}>{props.data.label}</label>
                                                {!props.isLastPair && <div style={{ borderBottom: "1px solid #D9D9D9", marginTop: "15px" }}></div>}
                                            </div>
                                        );
                                    },
                                }}
                                onChange={(selectedOptions) => {
                                    const selected = Array.isArray(selectedOptions) ? selectedOptions.map((option) => option.value) : [];
                                    setFieldValue("slots", selected);
                                }}
                                value={availableSlots.filter((option) => values.slots.includes(option.value))}
                            />
                            <ErrorMessage name="slots" component="div" className="text-danger fs-14 fw-400 mt-1" />
                        </FormInputLayout>
                        <FormInputLayout label="Panelist" formikName="panelist" required={false}>
                            <Select
                                isMulti
                                isSearchable={true}
                                styles={colourStylesFullWidth}
                                options={Panelist_labels_values}
                                components={{
                                    IndicatorSeparator: () => null,
                                }}
                                onChange={(selectedOptions) => {
                                    // Initialize an empty array for selected values
                                    const selectedValues = [];

                                    // Handle both single and multiple selections
                                    if (selectedOptions) {
                                        // If selectedOptions is an array
                                        if (Array.isArray(selectedOptions)) {
                                            selectedOptions.forEach((option) => {
                                                selectedValues.push(option.value); // Collect values from selected options
                                            });
                                        } else {
                                            // If selectedOptions is a single object
                                            selectedValues.push(selectedOptions.value); // Collect value from the single selected option
                                        }
                                    }
                                    setAddPanelist(selectedValues); // Update the addPanelist state
                                    setFieldValue("panelist", selectedValues); // Update Formik's field value
                                }}
                                value={Panelist_labels_values?.filter((option) => values?.panelist.includes(option?.value))}
                            />
                            <ErrorMessage name="panelist" component="div" className="text-danger fs-14 fw-400 mt-1" />
                        </FormInputLayout>
                        <FormInputLayout label="Secretariat" formikName="secretariat" required={false}>
                            <Select
                                isSearchable={false}
                                styles={colourStylesFullWidth}
                                options={Secritariat_labels_values}
                                components={{
                                    IndicatorSeparator: () => null,
                                }}
                                onChange={(selectedOption) => {
                                    setFieldValue("secretariat", selectedOption?.value);
                                }}
                                value={Secritariat_labels_values.find((option) => option.value === values?.secretariat)}
                            />
                            <ErrorMessage name="secretariat" component="div" className="text-danger fs-14 fw-400 mt-1" />
                        </FormInputLayout>

                        <div className="border-before pt-4"></div>
                        <div className="d-flex justify-content-end gap-4">
                            <div className="line-button d-flex gap-5 justify-content-end pt-5 btn_css">
                                <button className="cancel-btn" onClick={closePopup}>
                                    Cancel
                                </button>
                            </div>
                            <div className="right-content d-flex gap-5 justify-content-end pt-5 btn_css" type="submit">
                                <PlainButton type="" isLoading={loading}>
                                    Confirm
                                </PlainButton>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default ApplicationReadyForAssessmentForm;
